import { Component, OnInit, Input } from '@angular/core';
import { SummaryRating } from 'app/shared/models/summaryRating.model';

@Component({
    selector: 'app-chart-days-to-complete',
    templateUrl: './chart-days-to-complete.component.html',
    styleUrls: ['./chart-days-to-complete.component.css']
})
export class ChartDaysToCompletedComponent implements OnInit {
    @Input() daysToComplete: any[];
    avDaysToComplete: number;


    view: any[] = [160, 80];

    // options
    showXAxis = false;
    showYAxis = false;
    gradient = false;
    showLegend = false;
    showXAxisLabel = false;
    xAxisLabel = 'Days to Complete';
    showYAxisLabel = false;
    yAxisLabel = 'Instance';

    colorScheme = {
        domain: ['#4e9c89']
    };

    constructor() {
    }



    ngOnInit() {

        let valueSum = 0;
        let count = 0;
        const len = this.daysToComplete.length;
        let item = null;
        for (let i = 0; i < len; i++) {
            item = this.daysToComplete[i];
            valueSum = Number(item.name) + valueSum;
            count = count + item.value;
        }

        this.avDaysToComplete = valueSum / count;
    }

}
